import * as Yup from 'yup'

import { formValidation } from '../../../FormLegacy/validation'

export const convertUrlToFile = async (url, fileName, defaultFileName = 'browsedImage') => {
  const response = await fetch(url)
  const blob = await response.blob()

  const extension = blob.type.split('/')[1] === 'jpeg' ? '.jpg' : blob.type.split('/')[1] || ''

  const name = (fileName || defaultFileName) + (fileName && fileName.includes('.') ? '' : extension)

  return new File([blob], name, {
    type: blob.type,
  })
}

export const UPLOAD_IMAGE_STATUSES = {
  UPLOAD_IMAGE_SUCCESS: (fileName) => `File ${fileName && fileName + ' '}was successfully uploaded`,
  UPLOAD_IMAGE_ERROR: 'Error uploading the photo. Please try again',
}

export const GROUPS_ACTION_STATUSES = {
  ADD_NEW_GROUP_SUCCESS: (groupName) => `New interest group ${groupName} was successfully created`,
  ADD_NEW_GROUP_ERROR: (groupName) =>
    `Error occurred creating new interest group ${groupName}. Please try again `,
}

export const addNewGroupValidationSchema = Yup.object().shape({
  name: formValidation.required,
  description: formValidation.required,
  picture: Yup.mixed()
    .test('fileType', 'Invalid file format', (file) => {
      if (!file) return false
      return file && ['image/jpeg', 'image/png', 'image/jpg'].includes(file.type)
    })
    .test('fileSize', 'File size is too large', (file) => {
      if (!file) return false
      const maxSizeInBytes = 2097152 // 2MB
      return file && file.size <= maxSizeInBytes
    })
    .required('Required'),
})
